
import Slider from "react-slick";
import React from 'react';

export default function HealthcareBrand({ data, extraClass = ""  }) {


  const settingslogos = {
    dots: false,
    slidesToShow: 6,
    infinite: true,
    autoplay: true,
    slidesToScroll: 1,
    pauseOnHover: false,
    arrows: false,
    cssEase: "linear",
    autoplaySpeed: 0,
    initialSlide: 0,
    speed: 4000,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 599,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  };

  return (
    <section className={`health-patner ${extraClass}`}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-12 col-lg-9">
              {data?.title && ( <h4 className="heading center-heading"> {data?.title}  </h4> )}
          </div>
        </div>
      </div>
      <Slider {...settingslogos} className="health-brand-slider">
        {data.logos.map((logo, index) => (
          <div className="healthpartner-box" key={index}>
            <div className="health-inner">
              <img  src={logo.image} alt={logo.title}  className="img-responsive" width={logo?.width || 198} height={logo?.height || 80} loading="lazy" decoding="async"  />
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
}
